import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row no-wrap items-center full-width"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "row no-wrap base-padding base-margin-bottom justify-between items-center" }
const _hoisted_6 = { class: "row no-wrap justify-between base-margin items-start" }
const _hoisted_7 = { class: "text-grey q-mt-sm" }
const _hoisted_8 = { class: "q-mt-xs" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 1,
  class: "base-padding"
}
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttachmentIcon = _resolveComponent("AttachmentIcon")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_SIcon = _resolveComponent("SIcon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_SBanner = _resolveComponent("SBanner")!
  const _component_SBtn = _resolveComponent("SBtn")!
  const _component_Certificate = _resolveComponent("Certificate")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_s_banner = _resolveComponent("s-banner")!
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_Signer = _resolveComponent("Signer")!
  const _component_SModal = _resolveComponent("SModal")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["row items-center no-wrap", { 'justify-between': !_ctx.compact }])
  }, [
    (!_ctx.compact)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_AttachmentIcon, {
            file: _ctx.document,
            size: "large",
            "need-sign": _ctx.document.needSign,
            signed: !!_ctx.innerValue
          }, null, 8, ["file", "need-sign", "signed"]),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "s-link base-margin-right",
                title: _ctx.document.name,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)))
              }, _toDisplayString(_ctx.cropTextSmart(_ctx.document.name, 50)), 9, _hoisted_2))
            : (_openBlock(), _createBlock(_component_q_skeleton, {
                key: 1,
                width: "100%",
                height: "48px"
              }))
        ]))
      : _createCommentVNode("", true),
    (_ctx.compact && _ctx.loading)
      ? (_openBlock(), _createBlock(_component_q_spinner, {
          key: 1,
          size: "20px",
          color: "brand",
          class: "small-margin-right"
        }))
      : (_ctx.compact && _ctx.innerValue)
        ? (_openBlock(), _createBlock(_component_SIcon, {
            key: 2,
            name: "custom:files/signed",
            size: "middle",
            class: "small-margin-right"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, { "content-class": "s-tooltip" }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Файл подписан ЭЦП")
                ])),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.hasMenuItems)
      ? (_openBlock(), _createBlock(_component_q_btn, {
          key: 3,
          class: _normalizeClass({ 'text-grey': !_ctx.compact }),
          icon: "app:actions",
          dense: "",
          flat: "",
          disable: _ctx.loading
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_list, null, {
                  default: _withCtx(() => [
                    (_ctx.allowSigning)
                      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                          key: 0,
                          clickable: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDialog('certificates')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, { side: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_SIcon, { name: "custom:files/signed" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_item_section, null, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode("Подписать")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })), [
                          [_directive_close_popup]
                        ])
                      : _createCommentVNode("", true),
                    (_ctx.canDownloadSignatureMenuItem)
                      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                          key: 1,
                          clickable: "",
                          onClick: _ctx.downloadSignature
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, { side: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_SIcon, { name: "custom:files/download-signature" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_item_section, null, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode("Скачать подпись")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onClick"])), [
                          [_directive_close_popup]
                        ])
                      : _createCommentVNode("", true),
                    (_ctx.canShowSignersMenuItem)
                      ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                          key: 2,
                          clickable: "",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDialog('signers')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, { side: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_SIcon, { name: "custom:files/signers" })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_q_item_section, null, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode("Информация о подписантах")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })), [
                          [_directive_close_popup]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class", "disable"]))
      : _createCommentVNode("", true),
    _createVNode(_component_SModal, {
      modelValue: _ctx.showDialog,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showDialog) = $event)),
      persistent: "",
      title: _ctx.dialogTitle
    }, {
      default: _withCtx(() => [
        (_ctx.tab === 'certificates')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.signingPossible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_SBanner, {
                        class: "q-mr-md",
                        "with-icon": "",
                        type: "info"
                      }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode(" Убедитесь, что носитель с сертификатом ЭЦП вставлен в компьютер ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_SBtn, {
                        type: "secondary-info",
                        title: "Обновить список доступных сертификатов",
                        label: "Обновить",
                        onClick: _ctx.refreshCertificates
                      }, null, 8, ["onClick"])
                    ]),
                    _createVNode(_component_q_list, { class: "base-margin base-padding border-radius s-bordered s-max-height-300 s-scroll" }, {
                      default: _withCtx(() => [
                        (_ctx.certificates.length > 0)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.certificates, (cert, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: cert.thumbprint,
                                class: "small-margin-bottom"
                              }, [
                                _createVNode(_component_Certificate, {
                                  cert: cert,
                                  active: _ctx.thumbprint === cert.thumbprint,
                                  class: "cursor-pointer",
                                  onClick: ($event: any) => (_ctx.selectCertificate(cert))
                                }, null, 8, ["cert", "active", "onClick"]),
                                (index !== _ctx.certificates.length - 1 && _ctx.thumbprint !== cert.thumbprint)
                                  ? (_openBlock(), _createBlock(_component_q_separator, {
                                      key: 0,
                                      color: "brand-secondary",
                                      inset: ""
                                    }))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          : (_openBlock(), _createBlock(_component_s_banner, {
                              key: 1,
                              class: "q-mr-md",
                              "with-icon": "",
                              type: "warning"
                            }, {
                              default: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createTextVNode(" Список доступных сертификатов пуст ")
                              ])),
                              _: 1
                            })),
                        _createVNode(_component_q_inner_loading, { showing: _ctx.cryptoproLoading }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_spinner_gears, {
                              size: "50px",
                              color: "brand"
                            })
                          ]),
                          _: 1
                        }, 8, ["showing"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_q_form, {
                      ref: "resolutionForm",
                      class: "q-mb-md"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_input, {
                          modelValue: _ctx.description,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.description) = $event)),
                          class: "s-form-input col base-margin-x",
                          type: "textarea",
                          loading: _ctx.cryptoproLoading,
                          autogrow: "",
                          outlined: "",
                          dense: "",
                          clearable: "",
                          placeholder: "Ваша резолюция",
                          "hide-bottom-space": "",
                          rules: [_ctx.MaxLength(50)]
                        }, null, 8, ["modelValue", "loading", "rules"])
                      ]),
                      _: 1
                    }, 512),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_Transition, { name: "q-transition--scale" }, {
                        default: _withCtx(() => [
                          (_ctx.currentCertificate)
                            ? (_openBlock(), _createBlock(_component_Certificate, {
                                key: _ctx.thumbprint,
                                class: "full-width small-padding",
                                cert: _ctx.currentCertificate,
                                ribbon: ""
                              }, null, 8, ["cert"]))
                            : (_openBlock(), _createBlock(_component_s_banner, {
                                key: 1,
                                class: "q-mr-md",
                                "with-icon": "",
                                type: "warning"
                              }, {
                                default: _withCtx(() => _cache[11] || (_cache[11] = [
                                  _createTextVNode(" Пожалуйста, выберите сертификат, которым хотите подписать документ и нажмите на него! ")
                                ])),
                                _: 1
                              }))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_SBtn, {
                        type: "brand",
                        loading: _ctx.cryptoproLoading,
                        disable: !_ctx.thumbprint,
                        class: "base-margin-left",
                        label: "Подписать",
                        onClick: _ctx.sign
                      }, null, 8, ["loading", "disable", "onClick"])
                    ]),
                    _createVNode(_component_q_separator, {
                      color: "brand",
                      class: "base-margin-x"
                    }),
                    _createElementVNode("div", _hoisted_7, [
                      _cache[12] || (_cache[12] = _createElementVNode("span", null, "Служебная информация", -1)),
                      _createElementVNode("ul", _hoisted_8, [
                        _createElementVNode("li", null, "Версия плагина: " + _toDisplayString(_ctx.info.pluginVersion), 1),
                        _createElementVNode("li", null, "Версия криптопровайдера: " + _toDisplayString(_ctx.info.providerVersion), 1),
                        _createElementVNode("li", null, "Криптопровайдер: " + _toDisplayString(_ctx.info.providerName), 1)
                      ])
                    ])
                  ]))
                : (!_ctx.signingPossible && _ctx.cryptoproLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-grey" }, " Пожалуйста, подождите, идёт загрузка плагина для работы с криптопровайдером. ", -1)),
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-grey" }, "Подтвердите доступ к плагину, если браузер запросит!", -1)),
                      _createVNode(_component_q_skeleton, {
                        class: "base-margin-bottom",
                        height: "96px"
                      }),
                      _createVNode(_component_q_skeleton, {
                        class: "base-margin-bottom",
                        height: "96px"
                      }),
                      _createVNode(_component_q_skeleton, {
                        class: "base-margin-bottom",
                        height: "96px"
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[15] || (_cache[15] = [
                      _createTextVNode(" Для подписания документа необходимо установить "),
                      _createElementVNode("a", {
                        href: "https://cryptopro.ru/products/cades/plugin/get_2_0",
                        target: "_blank"
                      }, "плагин", -1),
                      _createTextVNode(" для работы с криптопровайдером и обновить страницу. ")
                    ])))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_ctx.innerSigners.length > 0)
                ? (_openBlock(), _createBlock(_component_q_list, {
                    key: 0,
                    class: "base-margin base-padding border-radius s-bordered s-max-height-600 s-scroll"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innerSigners, (signer, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: `${signer.serialNumber}-${index}`
                        }, [
                          _createVNode(_component_Signer, { signer: signer }, null, 8, ["signer"]),
                          (index !== _ctx.innerSigners.length - 1)
                            ? _withDirectives((_openBlock(), _createBlock(_component_q_separator, {
                                key: 0,
                                spaced: "",
                                inset: ""
                              }, null, 512)), [
                                [_vShow, !_ctx.cryptoproLoading]
                              ])
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, "Данный документ еще не был подписан"))
            ]))
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 2))
}